export enum EquipmentType {
    Sound = 0,
    Lightning = 1,
    Structure = 2,
    Video = 3,
    Computing = 4,
    Cabling = 5,
    Accessories = 6,
}